import {CheckoutContext} from "@/components/context/CheckoutContext.tsx";
import {PublicUserContext} from "@/components/context/PublicUserContextProvider.tsx";
import {createStyleContext} from "@/components/context/StyleContext.tsx";
import {UserContext} from "@/components/context/UserContextProvider.tsx";
import {ZendeskMessengerContext} from "@/components/context/ZendeskMessengerContext.tsx";
import {getPublicUserContext} from "@/components/context/utils.ts";
import {CurrentUserContext} from "@/lib/queries/accounts.ts";
import {useContext} from "react";

/**
 * @description Used in authenticated pages like dashboard
 */
export const useCurrentUserContext = (): CurrentUserContext & {userHasFeature: (name: string) => {}} => {
  return useContext(UserContext);
};

/**
 * @description Used in unauthenticated pages like marketing
 */
export const usePublicUserContext = (): PublicUserContext => {
  return useContext(PublicUserContext);
};

/**
 * @description Useful for components that are used in both authenticated and unauthenticated pages
 */
export const useCurrentOrPublicUserContext = (): PublicUserContext => {
  const currentUserContext = useCurrentUserContext();
  const publicUserContext = usePublicUserContext();
  return currentUserContext.user ? getPublicUserContext(currentUserContext) : publicUserContext;
};

export const useCheckoutContext = () => {
  return useContext(CheckoutContext);
};

export const useStyleContext = <VariantType>() => {
  return useContext(createStyleContext<VariantType>());
};

export const useZendeskMessenger = () => {
  return useContext(ZendeskMessengerContext);
};
